import React from 'react';
import classNames from '../../utility/classNames';

export default function CardLoader({ size = 'md' }) {
  return (
    <div className="w-full bg-neutral-50 rounded-lg overflow-hidden">
      <div className="animate-pulse flex-1 space-y-8">
        <div
          className={classNames(
            'w-full bg-primary rounded',
            size === 'md' && 'h-48 sm:h-96',
            size === 'sm' && 'h-24',
            size === 'lg' && 'h-[490px]'
          )}
        />
      </div>
      <div className="h-1/4 w-full flex-1 animate-pulse space-x-4 py-6">
        <div className="h-6 w-3/4 bg-primary rounded" />
      </div>
    </div>
  );
}
